module.exports = __webpack_public_path__ + "static/media/29ADMSPC13.ce4b53c9.jpg";